import { render, staticRenderFns } from "./create copy.vue?vue&type=template&id=2e33ca2c&scoped=true"
import script from "./create copy.vue?vue&type=script&lang=js"
export * from "./create copy.vue?vue&type=script&lang=js"
import style0 from "./create copy.vue?vue&type=style&index=0&id=2e33ca2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33ca2c",
  null
  
)

export default component.exports